import { Popover as PopoverPrimitive } from 'radix-ui';
import { forwardRef, type ComponentPropsWithoutRef } from 'react';

import { cn } from '../cn';
import { physicalSide, type LogicalSide } from './side';

export const Popover = PopoverPrimitive.Root;
export const PopoverTrigger = PopoverPrimitive.Trigger;
export const PopoverAnchor = PopoverPrimitive.Anchor;
export const PopoverClose = PopoverPrimitive.Close;

export const PopoverContent = forwardRef<HTMLDivElement, Omit<ComponentPropsWithoutRef<typeof PopoverPrimitive.Content>, 'side'> & { side?: LogicalSide }>(
  function PopoverContent({ className, align = 'start', sideOffset = 4, side = 'bottom', ...props }, ref) {
    return (
      <PopoverPrimitive.Portal>
        <PopoverPrimitive.Content
          ref={ref}
          side={physicalSide(side)}
          align={align}
          sideOffset={sideOffset}
          collisionPadding={8}
          className={cn(
            'z-(--z-popover) rounded-md border border-border bg-surface text-ink shadow-overlay outline-none data-[state=open]:animate-fade-in',
            className,
          )}
          {...props}
        />
      </PopoverPrimitive.Portal>
    );
  },
);
